module.exports = __webpack_public_path__ + "static/media/Infinity-1s-200px.b87fd3a7.gif";